<template>
  <div
    class="public_header"
    :class="{ grey: isThemeGrey, 'auth-theme': isAuthTheme }"
  >
    <div class="nav_left">
      <div class="logo">
        <img :src="pitchviewLogo" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { usePitchviewLogo } from "@/util/usePitchviewLogo";
import { computed } from "vue";
import { useRoute } from "vue-router";

const pitchviewLogo = usePitchviewLogo();

const route = useRoute();

const isAuthTheme = computed(() =>
  ["Login", "EmailVerification"].includes(String(route.name)),
);

const isThemeGrey = computed(() => route.meta.theme === "grey");
</script>

<style lang="scss" scoped>
$logo-height: 40px;

.logo {
  height: $logo-height;
}

.logo img {
  height: 100%;
  width: auto;
}

.public_header {
  padding: 15px 25px;
  text-align: left;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #dbdbdb;
}

.public_header.auth-theme {
  border-bottom-color: var(--classic-border, #dbdbdb);
}

.public_header.strong {
  border-bottom: 1px solid #d0d4d9;
}

.public_header.grey {
  border: none;
  background-color: #eff1f4;
}

.nav_left {
  display: flex;
  flex: 0;
  align-self: stretch;
  align-items: center;
}

.nav_right {
  margin-left: auto;
}

a {
  line-height: $logo-height;
  text-decoration: none;
  color: inherit;
}

.nav_middle {
  flex: 1;
}

.menu {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  color: #21395f;
  font-size: 0.9em;
}

.menu li {
  display: inline-block;
  padding: 0px 15px;
  line-height: 34px;
}

.menu li a {
  color: inherit;
  text-decoration: none;
}

.menu li a.router-link-exact-active {
  color: #36b6b9;
}
</style>
